import React from "react";

import useWindowWidth from "../../../hooks/useWindowWidth";
import { SponsorDogPromoCardFlat } from "./Flat/SponsorDogPromoCardFlat";
import { SponsorDogPromoCardSquare } from "./Square/SponsorDogPromoCardSquare";
export interface SponsorDogPromoCardProps {
	imgSrc: string;
	imgAlt: string;
	text: string;
	url: string;
}
export const SponsorDogPromoCard: React.FC<SponsorDogPromoCardProps> = ({
	...props
}) => {
	const screenWidth = useWindowWidth();
	if (screenWidth < 600)
		return (
			<SponsorDogPromoCardSquare {...props} type="SponsorDogPromoCardSquare" />
		);
	return <SponsorDogPromoCardFlat {...props} />;
};

export default SponsorDogPromoCard;
